import { render, staticRenderFns } from "./Policyassignments.vue?vue&type=template&id=b60c6cbe"
import script from "./Policyassignments.vue?vue&type=script&lang=js"
export * from "./Policyassignments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports